var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 671,
    height: 534,
    viewBox: "0 0 671 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.407 533.913L670.791 76.6317L670.774 76.649V76.2683V0H271.019L224.759 76.2683H582.616L356.632 461.157H275.449L452.232 161.536L173.429 161.778L129.281 234.55H321.085L144.459 533.913H402.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.451 407.714L92.4709 532.007H0.384766L73.5033 407.714H165.451Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7Icon);
export default __webpack_public_path__ + "static/media/7icon.a5b1183214d5518e0ead674ed1d0bba0.svg";
export { ForwardRef as ReactComponent };